import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("se_admin_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// Auto-logout on expired/invalid admin token (401 on any /admin/* route)
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    if (status === 401 && url.includes("/admin/")) {
      // Clear stale token so UI stops showing admin shell with broken calls
      localStorage.removeItem("se_admin_token");
      localStorage.removeItem("se_admin_email");
      // Redirect only if we are inside the admin area and not already on login
      if (typeof window !== "undefined") {
        const p = window.location.pathname;
        if (p.startsWith("/admin") && !p.startsWith("/admin/login")) {
          window.location.replace("/admin/login?expired=1");
        }
      }
    }
    return Promise.reject(err);
  }
);

export default api;
